import { render, staticRenderFns } from "./CosReport.vue?vue&type=template&id=72843c99"
import script from "./CosReport.vue?vue&type=script&lang=js"
export * from "./CosReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports